import { formatNumber, formatPercent } from '@angular/common';
import {
    CmpsScoreSectionTrendData,
    CmpsScoreSectionTrendType,
} from '@cmps/ng-kit';

import { TrendType } from '../../scorecard/core/trend-type.model';
import { OverallScore } from '../../scorecard/scorecard.model';

export function getTrendData(
    adjustedScore: OverallScore,
    originalScore: number,
    trendId: TrendType,
): CmpsScoreSectionTrendData {
    let trend =
        trendId === TrendType.UNKNOWN
            ? CmpsScoreSectionTrendType.UNKNOWN
            : CmpsScoreSectionTrendType.NO_CHANGE;
    let trendValue = trendId === TrendType.UNKNOWN ? 'NA' : '';
    let trendColor = '#000';

    const scoreDiff =
        adjustedScore != null && originalScore != null
            ? (adjustedScore.scoreValue - originalScore) / originalScore
            : 1;
    switch (trendId) {
        case TrendType.UP:
            trend = CmpsScoreSectionTrendType.UP;
            trendValue =
                scoreDiff !== 0
                    ? ` +${formatPercent(scoreDiff, 'en-CA', '1.2')}`
                    : formatPercent(scoreDiff, 'en-CA', '1.2');
            trendColor = '#1e60d4';
            break;
        case TrendType.DOWN:
            trend = CmpsScoreSectionTrendType.DOWN;
            trendValue = formatPercent(scoreDiff, 'en-CA', '1.2');
            trendColor = '#941000';
            break;
        case TrendType.NEUTRAL:
            trend = CmpsScoreSectionTrendType.NO_CHANGE;
            trendValue = '-';
            trendColor = '#000';
            break;
    }

    const trendTooltip = [
        {
            label: 'Current',
            value:
                adjustedScore != null
                    ? formatNumber(adjustedScore.scoreValue, 'en-CA', '1.0-2')
                    : '0',
        },
        {
            label: 'Previous',
            value:
                originalScore != null
                    ? formatNumber(originalScore, 'en-CA', '1.0-2')
                    : '0',
        },
        {
            label: '% Change',
            value: trendValue,
        },
    ];
    const trendTooltipWithoutData = [
        {
            label: 'Previous Scorecard not available for compare',
            value: null,
        },
    ];

    return {
        trend,
        trendValue,
        trendColor,
        trendTooltip:
            trend === CmpsScoreSectionTrendType.UNKNOWN
                ? trendTooltipWithoutData
                : trendTooltip,
    };
}
